var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_4983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7214 1.38082L20.6728 4.57463L28.8612 13.153L31.9099 9.95923C33.4846 8.30953 33.4846 5.63703 31.9099 3.98734L29.4281 1.38082C27.8534 -0.268869 25.3024 -0.268869 23.7277 1.38082H23.7214ZM19.2492 6.06595L4.56665 21.4543C3.91158 22.1406 3.43286 22.9918 3.16831 23.9222L0.938528 31.8606C0.781058 32.4214 0.925931 33.0219 1.31646 33.4311C1.70699 33.8402 2.28018 33.992 2.80928 33.8336L10.3868 31.4976C11.2749 31.2205 12.0875 30.719 12.7425 30.0327L27.4377 14.6444L19.2492 6.06595Z",
    fill: "#EFE7EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_4983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.25,
    height: 33.7857,
    fill: "white",
    transform: "translate(0.875 0.1073)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.9046cbd73d45ba86d661a1774880865c.svg";
export { ForwardRef as ReactComponent };